













import Vue from 'vue';

import store from '@/store';

import { OrgPacket } from '@/models/orgStructure';
import { BasePacketKind } from '@/models/packet';

import PacketSinglePoint from '@/views/authenticated/OrganizationPacketSinglePoint.vue';
import PacketMultiPoint from '@/views/authenticated/OrganizationPacketMultiPoint.vue';

export default Vue.extend({
  components: {
    PacketSinglePoint,
    PacketMultiPoint
  },

  props: {
    packetId: Number
  },

  computed: {
    packet(): OrgPacket {
      return store.getters.org.packet(this.packetId);
    },

    isSinglePoint(): boolean {
      return this.packet.packet.kind === BasePacketKind.SINGLE_POINT;
    }
  }
});
